import React from 'react';

interface CommentsIconProps {
  color?: string;
  height?: number | string;
  width?: number | string;
  opacity?: number;
  style?: React.CSSProperties;
  className?: string;
  'aria-label'?: string;
}

const CommentsIcon: React.FC<CommentsIconProps> = ({
  color = '#2372b9',
  height = 24,
  width = 24,
  opacity = 1,
  style,
  className,
  'aria-label': ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={height}
    width={width}
    viewBox="0 0 20 20"
    style={{ opacity, ...style }}
    className={className}
    aria-label={ariaLabel}
    role={ariaLabel ? 'img' : 'presentation'}
    fill="none"
  >
    <path
      d="M0 12V3.6C0 1.6125 1.6125 0 3.6 0H15.6C17.5875 0 19.2 1.6125 19.2 3.6V12C19.2 13.9875 17.5875 15.6 15.6 15.6H11.1C10.905 15.6 10.7175 15.6637 10.56 15.78L6.24 19.02C6.0825 19.1363 5.895 19.2 5.7 19.2C5.20125 19.2 4.8 18.7987 4.8 18.3V15.6H3.6C1.6125 15.6 0 13.9875 0 12Z"
      fill={color}
    />
  </svg>
);

export default CommentsIcon;
